import axios from "axios";
import firebase from "firebase/app";
import moment from "moment";

const state = {
  live: {},
  nextEvent: {},
  streamPassword: "",
  nextEventListener: null,
  dashUrl: ""
};

const mutations = {
  SET_LIVECHANNEL(state, data) {
    state.live = data;
  },
  SET_NEXT_EVENT(state, data) {
    state.nextEvent = data;
  },
  SET_STREAMING_PWD(state, data) {
    state.streamPassword = data;
  },
  SET_NEXT_EVENT_LISTENER(state, data) {
    state.nextEventListener = data;
  },
  SET_DASH_URL(state, data) {
    state.dashUrl = data;
  }
};

const actions = {
  initializeScheduledLiveclass({ commit, rootState }, data) {
    const nextEventListener = rootState.Database.db.collection("livechannels").doc(data.studioId)
      .collection("schedules").doc(data.classId).onSnapshot({ includeMetadataChanges: true }, nextEventDoc => {
        commit("SET_NEXT_EVENT", nextEventDoc.data());
      });
    const url = `https://us-central1-${rootState.Database.projectID}` +
      `.cloudfunctions.net/api/streaming/dash/${data.studioId}/${data.classId}`;
    firebase.auth().currentUser.getIdToken(true).then(token => {
      axios({
        method: "get",
        url,
        headers: { "Authorization": `Bearer ${token}` },
        responseType: "json"
      }).then(response => {
        if (response.data.status === "ok") {
          commit("SET_DASH_URL", response.data.dashUrl);
        }
      }).catch(console.error);
    });
    commit("SET_NEXT_EVENT_LISTENER", nextEventListener);
  },
  unsubscribeScheduledLiveclassListener({ commit, state }) {
    if (state.nextEventListener) {
      state.nextEventListener();
    }
    commit("SET_NEXT_EVENT_LISTENER", null);
  },
  initializeLivechannel({ commit, rootState }, liveChannelId) {
    rootState.Database.db.collection("livechannels").doc(liveChannelId).onSnapshot({
      includeMetadataChanges: true
    }, {
      next: doc => {
        if (doc.exists && doc.data().enabled === true && !doc.data().deleted) {
          commit("SET_LIVECHANNEL", doc.data());
          const nextEvent = doc.data().nextEvent;
          if (nextEvent !== null && nextEvent !== "-") {
            rootState.Database.db.collection("livechannels").doc(liveChannelId)
              .collection("schedules").doc(nextEvent)
              .get()
              .then(nextEventDoc => {
                commit("SET_NEXT_EVENT", nextEventDoc.data());
              });
          } else if (nextEvent === "-") {
            commit("SET_NEXT_EVENT", {});
            
          }
        }
      }
    });

    const url = `https://us-central1-${rootState.Database.projectID}` +
      `.cloudfunctions.net/api/streaming/decrypt/${liveChannelId}/`;
    firebase.auth().currentUser.getIdToken(true).then(token => {
      axios({
        method: "get",
        url,
        headers: { "Authorization": `Bearer ${token}` },
        responseType: "json"
      }).then(response => {
        commit("SET_STREAMING_PWD", response.data.streamPassword);
      }).catch(console.error);
    });
  },

};

const getters = {
  getNextEvent(state) {
    return state.nextEvent;
  },
  getDashUrl(state) {
    return state.dashUrl;
  },
  getNextEventDateFormatted(state) {
    if (state.nextEvent) {
      return moment(state.nextEvent.date).format("DD.MM.YYYY");
    }
    return "";
  },
  getStreamingAvailable(state) {
    if (state.nextEvent !== null && state.nextEvent.status === "idle") {
      const now = moment();
      const nextEventTime = moment(`${state.nextEvent.date} ${state.nextEvent.time}`, "YYYY-MM-DD HH:mm");
      if (nextEventTime.diff(now, "minutes") >= -10 && nextEventTime.diff(now, "minutes") <= 10) {
        return true;
      }
            
      return false;
            
    }
    return false;
  },
  getLivechannel() {
    return state.live;
  },
  getStreamingPassword() {
    return state.streamPassword;
  }
};

export default {
  state,
  actions,
  getters,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/Live.js